module.exports = __webpack_public_path__ + "files/bc6ae8271f56e4ad3876f91e6f1e5184.png";